import { Share } from 'react-native';

export const shareText = async (shareText: string) => {
  return Share.share({
    url: shareText,
    message: shareText,
  });
};
